export const NEW_THREAD_ID = 'new'
